import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MenuItem } from '../../core/models/menu.model';
import { DataService } from '../../core/services/data.service';
import { ImgSlotComponent } from './img-slot.component';
import { TagComponent } from './tag.component';
import { PriceComponent } from './price.component';
import { IconComponent } from './icon.component';
import { SoldOutVeilComponent } from './sold-out-veil.component';

/** Full-width menu list row. */
@Component({
  selector: 'app-item-row',
  standalone: true,
  imports: [NgIf, ImgSlotComponent, TagComponent, PriceComponent, IconComponent, SoldOutVeilComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div (click)="open.emit(item)"
      [style.border-bottom]="last ? 'none' : '1px solid var(--fr-border)'"
      [style.opacity]="item.soldout ? 0.92 : 1"
      style="display:flex;gap:13px;padding:14px 16px;cursor:pointer;align-items:center;position:relative">
      <div style="flex:1;min-width:0">
        <div style="display:flex;align-items:center;gap:7px;margin-bottom:3px">
          <span style="font-weight:700;font-size:15.5px;letter-spacing:-0.01em;color:var(--fr-text)">{{ item.name }}</span>
          <app-icon *ngIf="item.tags.includes('spicy')" name="solar:fire-bold" [size]="14" color="var(--brand)"></app-icon>
        </div>
        <p style="margin:0 0 8px;font-size:13px;line-height:1.45;color:var(--fr-text-2);display:-webkit-box;
                  -webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">{{ item.desc }}</p>
        <div style="display:flex;align-items:center;gap:8px">
          <app-price [value]="item.price" [size]="15"></app-price>
          <app-tag *ngIf="item.tags.includes('best')" kind="best"></app-tag>
          <app-tag *ngIf="item.tags.includes('new')" kind="new"></app-tag>
        </div>
      </div>
      <div style="position:relative;flex-shrink:0">
        <app-img-slot [src]="photo" [tone]="item.tone" [radius]="13" style="width:96px;height:96px">
          <app-sold-out-veil *ngIf="item.soldout" [small]="true"></app-sold-out-veil>
        </app-img-slot>
        <span *ngIf="qty > 0 && !item.soldout" class="fr-num"
          style="position:absolute;top:-6px;inset-inline-end:-6px;min-width:22px;height:22px;padding:0 6px;border-radius:11px;
                 border:2px solid var(--fr-surface);background:var(--brand);color:#fff;font-size:12px;font-weight:750;
                 display:flex;align-items:center;justify-content:center">{{ qty }}</span>
      </div>
    </div>`,
})
export class ItemRowComponent {
  @Input() item!: MenuItem;
  @Input() qty = 0;
  @Input() last = false;
  @Output() open = new EventEmitter<MenuItem>();

  constructor(private data: DataService) {}
  get photo(): string | null { return this.data.photoFor(this.item.id); }
}
